import React from "react";
import { Facebook, Instagram } from "lucide-react";

export default function Footer() {
    return (
        <footer className="bg-[#090D16] border-t border-accent/15 text-center text-xs text-muted/60 py-12 px-6 space-y-6 relative z-10">
            
            {/* Icone Social con Micro-animazione di Sollevamento */}
            <div className="flex justify-center gap-4">
                <a 
                    href="https://www.facebook.com/ilbalconcinoavetrana" 
                    target="_blank" 
                    rel="noreferrer" 
                    aria-label="Seguici su Facebook"
                    className="p-2.5 bg-[#0D121F] border border-accent/20 rounded-xl text-muted/80 hover:text-primary hover:border-primary/40 hover:-translate-y-0.5 transition-all duration-300"
                >
                    <Facebook className="w-4 h-4" />
                </a>
                <a 
                    href="https://www.instagram.com/ilbalconcinofoodbeer/" 
                    target="_blank" 
                    rel="noreferrer" 
                    aria-label="Seguici su Instagram"
                    className="p-2.5 bg-[#0D121F] border border-accent/20 rounded-xl text-muted/80 hover:text-primary hover:border-primary/40 hover:-translate-y-0.5 transition-all duration-300"
                >
                    <Instagram className="w-4 h-4" />
                </a>
            </div>

            {/* Note Legali, Partita IVA e Link di Servizio */}
            <div className="space-y-2 max-w-md mx-auto text-[11px] tracking-wide">
                <p className="text-secondary/70 font-medium text-xs tracking-widest uppercase">
                    Il Balconcino Food & Beer
                </p>
                
                <p>
                    Via Piave, 13 — 74020 Avetrana (TA)
                </p>
            </div>

            {/* Separatore minimale */}
            <div className="w-8 h-[1px] bg-accent/20 mx-auto" />

            {/* Copyright Dinamico */}
            <p className="tracking-widest text-[10px] font-medium uppercase text-muted/40">
                © {new Date().getFullYear()} Tutti i diritti riservati.
            </p>
        </footer>
    );
}